import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import { TrackedLink, withTracking } from '../xing-tracking';
import trackings from '../trackings';
import styles from './Help.css';

export const createHelpLink = (locale, pathname) => {
  let faqUrl = `https://faq.xing.com/${locale === 'de' ? 'de' : 'en'}`;
  let match = /(\/app\/|\/)(\w+-?\w+)([?/]|$)/.exec(pathname);
  faqUrl += match && match.length > 2 ? `?app=${match[2]}` : '';
  return faqUrl;
};

const Help = ({ helpLink, location: { pathname }, intl: { locale } }) => (
  <TrackedLink
    trackingKey="header"
    target="_blank"
    rel="noopener noreferrer"
    className={styles.help}
    href={helpLink || createHelpLink(locale, pathname)}
  >
    <FormattedMessage id="VERTICAL_NAVIGATION_HEADER_HELP">
      {text => text}
    </FormattedMessage>
  </TrackedLink>
);

Help.propTypes = {
  helpLink: PropTypes.string,
  intl: PropTypes.shape({ locale: PropTypes.string }),
  location: PropTypes.shape({ pathname: PropTypes.string }),
};

export default withRouter(injectIntl(withTracking(trackings)(Help)));
